import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardLeadRoutes = [
    {
        key: "lead-list",
        exact: true,
        path: `${APP_PREFIX_PATH}/reward/lead/list`,
        component: React.lazy(() => import("views/reward-views/lead/pages/LeadList")),
    },
    {
        key: "lead-detail",
        exact: true,
        path: `${APP_PREFIX_PATH}/reward/lead/detail/:id`,
        component: React.lazy(() => import("views/reward-views/lead/pages/LeadDetail")),
    }
];